import React from "react";
import { Fab, Tooltip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const GoBackButton = ({ onClick }) => {
  const handleClick = () => onClick();

  return (
    <Tooltip title="Voltar para profissionais" placement="left">
      <Fab
        aria-label="go-back"
        onClick={handleClick}
        sx={{
          position: "fixed",
          top: "20%",
          left: "5%",
          zIndex: 9999,
          backgroundColor: "#104467",
          "&:hover": {
            backgroundColor: "#08273b",
          },
        }}
      >
        <ArrowBackIcon fontSize={"large"} sx={{ color: "white" }} />
      </Fab>
    </Tooltip>
  );
};

export default GoBackButton;
